import { render, staticRenderFns } from "./addStoreMsg.vue?vue&type=template&id=22f190e6"
import script from "./addStoreMsg.vue?vue&type=script&lang=js"
export * from "./addStoreMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports